<template>
  <div class="h-100 w-100 px-0 position-absolute">
    <div class="h-100 w-100 overflow-auto">
      <Message v-for="(message, index) in getMessages" :message="message" :key="index" :index="index" :active="active" v-on:changeMessage="changeMessage"/>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import Message from './Message'

  /* TODO -
      highlight inactive participants in red
      hide any message threads where logged in user is inactive
  */
  export default {
    name: 'Messages',
    props: ['client'],
    components: { Message },
    data() {
      return {
        messageCounts: {}
      }
    },
    computed: {
      ...mapGetters([
        'getMessages',
        'getMyInfo',
        'newMessage',
        'newSignup',
        'getMessageParticipants'
      ]),
      active() {
        let result = 0
        if (this.$route.query.messageId) {
          this.getMessages.forEach((m, i) => {
            if (m.messageId === this.$route.query.messageId) result = i
          })
        }
        return result
      }
    },
    methods: {
      ...mapActions([
        'loadMessages',
        'getMessageThreadCount',
        'getMe',
        'loadAvatars'
      ]),
      goBack() {
        this.$router.go(-1)
      },
      changeMessage({ index, message }) {
        this.$router.push({name: 'messages', query: {messageId: message.messageId, threadId: message.threadId}})
      }
    },
    async create() {
      await this.getMe()
    },
    async mounted() {
      // await this.loadMessages() This is completed in router
      if (this.getMyInfo.hasRoles) {
        this.$store.commit('MY_MESSAGE_THREAD', { results: [] })
      }
    },
    watch: {
      getMessages: function(newVal, oldVal) {
        let messageThreadsLength = newVal.length
        for (let i = 0; i < messageThreadsLength; i++) {
          this.messageCounts[newVal[i].threadId] = newVal[i].totalMessages
        }
      },
      newMessage: async function(newVal, oldVal) {
        const topic = newVal.topic
        const threadId = topic.split(':').pop()
        let response = await this.getMessageThreadCount(newVal.message._id)
        let messagesCount = response.total
        this.getMessages.forEach(message => {
          this.loadAvatars(message)
          if (message.threadId === threadId) {
            message.turnRed = true
          }
        })
        this.messageCounts[threadId] = messagesCount
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/Messaging/Messages.vue?8fe4f69c